<template>
  <div class="page-body">

    <b-card class="content-card">
      <h1 class="text-right">
        تنظیمات عملیات
      </h1>

      <hr class="mb-3">

      <template v-if="loading">
        <div class="p-5 d-flex align-items-center justify-content-center">
          <BaseLoading/>
        </div>
      </template>
      <template v-else>
        <b-row>
          <b-col :cols="6">
            <div
              class="d-flex align-items-center justify-content-start mb-3"
              v-for="(item,index) in actions"
              :key="index"
            >
              <BaseLoading
                v-if="item.loading"
                class="mr-3"
                :size="20"
                :border-width="3"/>
              <b-form-checkbox
                :disabled="item.loading"
                v-model="item.isDisabled"
                @change="toggleActionStatus(item,$event)"
                switch size="lg">
                <div class="d-flex align-items-center justify-content-start">
              <span class="ml-2">
                {{ item.name }}
              </span>
                  <b-badge
                    :variant="item.isDisabled ? 'danger' : 'success'"
                    style="font-size: 12px">
                    <template v-if="item.isDisabled">
                      غیر فعال
                    </template>

                    <template v-else>
                      فعال
                    </template>

                  </b-badge>
                </div>
              </b-form-checkbox>
            </div>
          </b-col>

          <b-col :cols="6">
            <div class="d-flex align-items-center justify-content-between w-100 mb-3">
              <b class="text-right">
                ثبت آدرس کیف پول های مشکوک
              </b>

              <b-button
                @click="addNewAddress"
                variant="success">
                <i class="fa fa-plus-square"></i>
                افزودن مورد جدید
              </b-button>
            </div>
            <div class="d-flex align-items-center justify-content-center flex-column">
              <div
                v-for="(item,index) in suspiciousCryptoWalletsAddress.addresses"
                :key="index"
                class="w-100 d-flex align-items-center justify-content-center my-2">
                <b-button
                  @click="removeAddress(index)"
                  class="ml-1"
                  variant="outline-danger">
                  <i class="fa fa-trash-alt"></i>
                </b-button>
                <b-input :value="item" @input="updateAddressItem($event,index)"/>
              </div>
              <base-button
                class="mt-3"
                block
                :loading="suspiciousCryptoWalletsAddress.loading"
                @click="addSuspiciousCryptoWalletsAddress"
              >
                ثبت ادرس ها
              </base-button>
            </div>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </div>
</template>

<script>
import BaseLoading from "@/components/BaseLoading"
import {
  fetchOperationStatus,
  submitSuspiciousCryptoWalletsAddresses,
  updateOperationStatus
} from "@/httpservices/Oprations";
import Swal from "vue-sweetalert2";

export default {
  name: "Operations",

  components: {
    BaseLoading
  },

  data() {
    return {
      suspiciousCryptoWalletsAddress: {
        loading: false,
        addresses: [],
      },
      loading: true,
      actions: [
        {
          name: "واریز تومان",
          key: "FiatDeposit",
          loading: false,
          isDisabled: false,
          detail: "",
        },
        {
          name: "برداشت تومان",
          key: "FiatWithdrawal",
          loading: false,
          isDisabled: false,
          detail: ""
        },
        {
          name: "واریز رمزارز",
          key: "CryptoDeposit",
          loading: false,
          isDisabled: false,
          detail: ""
        },
        {
          name: "برداشت رمزارز",
          key: "CryptoWithdrawal",
          loading: false,
          isDisabled: false,
          detail: ""
        },
        {
          name: "تبدیل",
          key: "Swap",
          loading: false,
          isDisabled: false,
          detail: ""
        },
        {
          name: "تبدیل پرفکت مانی",
          key: "PerfectMoneySwap",
          loading: false,
          isDisabled: false,
          detail: ""
        },
        {
          name: "برداشت پرفکت مانی",
          key: "PerfectMoneyWithdrawal",
          loading: false,
          isDisabled: false,
          detail: ""
        },
        {
          name: "دریافت کد پرفکت مانی",
          key: "PerfectMoneyVoucherCreate",
          loading: false,
          isDisabled: false,
          detail: ""
        },
        {
          name: "واریز پرفکت مانی با کد",
          key: "PerfectMoneyVoucherRedeem",
          loading: false,
          isDisabled: false,
          detail: ""
        },
      ],
    }
  },

  mounted() {
    this.fetchSuspiciousCryptoWalletsAddresses();
    this.getOperationsStatus();
  },

  methods: {

    updateAddressItem(value, index) {
      console.log({value, index})
      this.suspiciousCryptoWalletsAddress.addresses[index] = value;
    },

    addNewAddress() {
      this.suspiciousCryptoWalletsAddress.addresses.unshift("");
    },

    removeAddress(index) {
      const confirmed = window.confirm('آیا مطمئن هستید ؟')
      if (!confirmed) return;
      this.suspiciousCryptoWalletsAddress.addresses.splice(index, 1)
    },

    async addSuspiciousCryptoWalletsAddress() {
      this.suspiciousCryptoWalletsAddress.loading = true;
      try {
        await submitSuspiciousCryptoWalletsAddresses(this.suspiciousCryptoWalletsAddress.addresses.filter(item => item));
        this.$swal.fire({
          icon: "success",
          title: "با موفقیت انجام شد.",
          confirmButtonText: "باشه"
        });
      } catch (e) {
        console.log(e)
      }
      this.suspiciousCryptoWalletsAddress.loading = false;
    },

    async fetchSuspiciousCryptoWalletsAddresses() {
      try {
        const {suspiciousCryptoWalletsAddresses =[]} = (await fetchOperationStatus()).data;
        this.suspiciousCryptoWalletsAddress.addresses = suspiciousCryptoWalletsAddresses || [];
      } catch (e) {
        console.log(e)
      }
    },

    async toggleActionStatus(action, status) {
      action.loading = true;
      try {
        await updateOperationStatus({
          type: action.key,
          isDisabled: status,
          detail: "String"
        });
        this.$swal.fire({
          position: "center",
          icon: "success",
          title: "با موفقیت انجام شد.",
          confirmButtonText: "باشه",
          showConfirmButton: true,
          timer: 1500,
        });
        action.isDisabled = status;
      } catch (e) {
        console.log(e)
      }
      action.loading = false;
    },

    async getOperationsStatus() {
      this.loading = true;
      try {
        const {temporaryDisabling} = (await fetchOperationStatus()).data;
        this.actions = this.actions.map(item => {
          return {
            ...item,
            loading: false,
            isDisabled: temporaryDisabling.find(i => i.type === item.key).isDisabled || false,
          }
        })


      } catch (e) {
        console.log(e)
      }

      this.loading = false;
    }
  }
}
</script>

<style scoped>

</style>
